<div class="d-flex flex-wrap">
  <div class="price d-inline-block font-size-primary font-weight-bold"
    *ngIf="!menuItem.discount || !menuItem.discountType; else discountedView">
    <span *ngIf="menuItem.priceDescription" class="mr-1 font-size-primary theme-color-subtitle-3">
      {{ menuItem.priceDescription }}
    </span>
    <span *ngIf="menuItem.price > 0" class="theme-color-subtitle-3">
      {{ menuItem.price | formatPrice: locale:currency:currencySymbol }}
      <span *ngIf="menuItem.consumption && menuItem.consumption != menuItem.price">
        <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
        {{ menuItem.consumption | formatPrice: locale:currency:currencySymbol }}
      </span>
    </span>
    <span class="mr-1 font-size-primary theme-color-subtitle-3"
      *ngIf="menuItem.price == 0 && menuItem.variants && menuItem.variants.length > 0 && !menuItem.priceDescription">
      {{'public.global.standard' | translate}}
    </span>
  </div>
  <ng-template #discountedView>
    <div class="price font-size-primary"
      *ngIf="menuItem.discount && menuItem.discountType=='MONETARY'; else discountedPercentileView">
      <span *ngIf="menuItem.priceDescription" class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3">
        {{ menuItem.priceDescription }}
      </span>
      <div class="d-inline-block">
        <span class="strikethrough mr-1 font-size-primary">
          {{ menuItem.price | formatPrice: locale:currency:currencySymbol }}</span>
        <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
          {{ menuItem.price - menuItem.discount | formatPrice: locale:currency:currencySymbol }}
        </span>
        <i class="fa-solid fa-tag ml-2 mr-1 discounted-price fs-12"></i>
        <span *ngIf="menuItem.consumption && menuItem.consumption != menuItem.price">
          <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
          <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
            {{ menuItem.consumption | formatPrice: locale:currency:currencySymbol }}
          </span>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template #discountedPercentileView>
    <div class="price font-size-primary">
      <span *ngIf="menuItem.priceDescription" class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3">
        {{ menuItem.priceDescription }}
      </span>
      <div class="d-inline-block">
        <span class="strikethrough mr-1 font-size-primary">
          {{ menuItem.price | formatPrice: locale:currency:currencySymbol }}
        </span>
        <span class="ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
          {{ (menuItem.price * (100 - menuItem.discount) / 100) | formatPrice: locale:currency:currencySymbol }}
        </span>
        <i class="fa-solid fa-tag ml-2 mr-1 discounted-price fs-12"></i>
        <span class="discounted-price font-size-primary font-weight-bold">
          - {{ menuItem.discount | number}}%
        </span>
        <span *ngIf="menuItem.consumption && menuItem.consumption != menuItem.price">
          <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
          <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
            {{ menuItem.consumption | formatPrice: locale:currency:currencySymbol }}
          </span>
        </span>
      </div>
    </div>
  </ng-template>
  <ng-container>
    <span class="variant font-size-primary" *ngFor="let variant of menuItem.variants">
      <span *ngIf="variant.priceDescription" class="mr-1 font-size-primary font-weight-bold theme-color-subtitle-3">
        {{ variant.priceDescription }}
      </span>
      <span class="font-weight-bold theme-color-subtitle-3" [ngClass]="{'d-none' : variant.price == 0}"
        *ngIf="!variant.discount || !variant.discountType; else variantDiscountedView">
        {{ variant.price | formatPrice: locale:currency:currencySymbol }}
        <span *ngIf="variant.consumption && variant.consumption != menuItem.price">
          <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
          {{ variant.consumption | formatPrice: locale:currency:currencySymbol }}
        </span>
      </span>
      <ng-template #variantDiscountedView>
        <span class="font-size-primary"
          *ngIf="variant.discount && variant.discountType=='MONETARY'; else variantPercentileView">
          <span>
            <span class="strikethrough mr-1 font-size-primary">
              {{ variant.price | formatPrice: locale:currency:currencySymbol }}
            </span>
            <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
              {{ variant.price - variant.discount | formatPrice: locale:currency:currencySymbol }}
            </span>
            <i class="fa-solid fa-tag ml-2 discounted-price fs-12"></i>
            <span *ngIf="variant.consumption && variant.consumption != variant.price">
              <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
              <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
                {{ variant.consumption | formatPrice: locale:currency:currencySymbol }}
              </span>
            </span>
          </span>
        </span>
      </ng-template>
      <ng-template #variantPercentileView>
        <span class="font-size-primary">
          <span>
            <span class="strikethrough mr-1 font-size-primary">
              {{ variant.price | formatPrice: locale:currency:currencySymbol }}
            </span>
            <span class="ml-1 font-size-primary font-weight-bold  theme-color-subtitle-3">
              {{ (variant.price * (100 - variant.discount) / 100) | formatPrice: locale:currency:currencySymbol }}
            </span>
            <i class="fa-solid fa-tag ml-2 discounted-price fs-12"></i>
            <span class="discounted-price ml-2 font-weight-bold">
              - {{ variant.discount | number }}%
            </span>
            <span *ngIf="variant.consumption && variant.consumption != variant.price">
              <i class="fa-solid fa-arrow-right" style="color: #000000;"></i>
              <span class="discounted-price ml-1 font-size-primary font-weight-bold theme-color-subtitle-3">
                {{ variant.consumption | formatPrice: locale:currency:currencySymbol }}
              </span>
            </span>
          </span>
        </span>
      </ng-template>
    </span>
  </ng-container>
</div>